export default __webpack_public_path__ + "static/media/Slide23.4d498750.jpg";